import isString from 'lodash/isString';

export const isValidDateStr = (value?: string | null) =>
  isString(value) && new Date(value).toString() !== 'Invalid Date';

export const isFutureDateStr = (value?: string | null) =>
  isString(value) && new Date(value).getTime() > new Date().getTime();
